export const GIFT_CARD_PAYMENT_SYSTEM_CARD_UUID = '4f0336a4-ca8b-11ee-9e2f-0050560133fc';
export const PAYMENT_METHOD_1C_SBP_UUID = '4cfa027d-d552-11f0-9e5f-0050560133fc';
export const GIFT_CARD_PAYMENT_SYSTEM_SBP_UUID = PAYMENT_METHOD_1C_SBP_UUID;

export const PAYMENT_METHOD_SBP_UUID = 'db221ac5-4d21-465b-a7ea-776bb1f114fe';

export const GIFT_CARD_PAYMENT_SYSTEM_UUIDS = [
  GIFT_CARD_PAYMENT_SYSTEM_SBP_UUID,
  GIFT_CARD_PAYMENT_SYSTEM_CARD_UUID
] as const;
